import { ValidAccountState } from '@/presentation/contexts/auth/account-provider'
import useAccount from '@/presentation/hooks/auth/use-account'
import { useQueryClient } from 'react-query'
import { RouteObject } from 'react-router-dom'
import {
  makeOnboarding2Page,
  makeOnboarding3Page,
  makeOnboarding4Page,
  makeOnboardingPersonalDataPage,
  makeOnboardingCompletedPage,
  makeOnboardingLayout,
  makeOnboardingSecurityPage,
  makeOnboardingWelcomePage,
  makeOnboardingProfessionalTrajectoryPage
} from '@/main/factories/pages'
import OnboardingImageLoader from '../loaders/onboarding/onboarding-image-loader'
import OnboardingMainLayoutLoader from '../loaders/onboarding/onboarding-main-layout-loader'
import OnboardingStepOptionsLoader from '../loaders/onboarding/onboarding-step-options-loader'
import OnboardingStep4OptionsLoader from '../loaders/onboarding/onboarding-step-4-options-loader'
import SimpleImageLoader from '../loaders/simple-image-loader'
import PathConstants from '../path-contants'

const {
  ONBOADING,
  ONBOARDING_PERSONAL_DATA,
  ONBOARDING_PROFESSIONAL_TRAJECTORY,
  ONBOADING_2,
  ONBOADING_3,
  ONBOADING_4,
  ONBOADING_SECURITY,
  ONBOADING_COMPLETED
} = PathConstants.Routes

const BuildOnboardingRoutes = (): RouteObject[] => {
  const [account] = useAccount() as ValidAccountState
  const queryClient = useQueryClient()

  return [
    {
      element: makeOnboardingLayout(),
      loader: new OnboardingMainLayoutLoader(account, queryClient).loader,
      children: [
        {
          path: ONBOADING.value,
          element: makeOnboardingWelcomePage(),
          loader: new OnboardingImageLoader(
            account,
            import('@images/student-congrats.svg'),
            queryClient
          ).loader
        },
        {
          path: ONBOARDING_PERSONAL_DATA.value,
          element: makeOnboardingPersonalDataPage(),
          loader: new OnboardingStepOptionsLoader(account, queryClient, 1).loader
        },
        {
          path: ONBOADING_2.value,
          element: makeOnboarding2Page()
        },
        {
          path: ONBOARDING_PROFESSIONAL_TRAJECTORY.value,
          element: makeOnboardingProfessionalTrajectoryPage(),
          loader: new OnboardingStepOptionsLoader(account, queryClient, 1).loader
        },
        {
          path: ONBOADING_3.value,
          element: makeOnboarding3Page(),
          loader: new OnboardingStepOptionsLoader(account, queryClient, 3).loader
        },
        {
          path: ONBOADING_4.value,
          element: makeOnboarding4Page(),
          loader: new OnboardingStep4OptionsLoader(account, queryClient).loader
        },
        {
          path: ONBOADING_SECURITY.value,
          element: makeOnboardingSecurityPage(),
          loader: new OnboardingImageLoader(
            account,
            import('@images/google-auth-sso.svg'),
            queryClient
          ).loader
        }
      ]
    },
    {
      path: ONBOADING_COMPLETED.value,
      element: makeOnboardingCompletedPage(),
      loader: new SimpleImageLoader(account, import('@images/completed.svg')).loader
    }
  ]
}

export default BuildOnboardingRoutes
